import Component from './Auth';
import selectors from './selectors';
import reducer from './reducer';

export default {
  Component,
  selectors,
  reducer,
};
